import React, { Component } from 'react';
import {
  Badge,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Nav,
  NavItem,
  NavbarToggler,
  NavbarBrand,
  DropdownToggle,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import { storedb } from '../../views/client/storedb'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Offline } from "react-detect-offline";
import { isMobileAndTablet } from '../../views/client/actions';
import EnvConfig from '../../config/env';
import AppConfig from '../../config/app';
import Online from './Onlines';

// Import actions
import { headerRequest, headerSetActiveBranchRequest } from './actions'

import {
  ACCESS_DENIED_ACTION,
  HEADER_REQUEST_SUCCESS,
} from './constants'

import ToastElement from './_ToastElement'
import Clock from './_Clock'
import AccessDenied from './_AccessDenied'
import CheckChangePassword from './_CheckChangePassword'
import { logout } from '../../views/client/actions'

import {
  parserToken
} from '../../views/client/actions'

class Header extends Component {
  _storeDb = null;

  constructor(props, context) {
    super(props, context);

    this.state = {
      dropdownOpen: new Array(2).fill(false),
      alertIds: [],
      curTime: new Date().toLocaleString(),
      modalAceessDenedFlag: false,
      modalChangePasswordFlag: false,
      data: {
        user: {},
        notifications: [],
      },
      showFbMsg: false,
      flagFbMsg: true,
    };

    this.toggle = this.toggle.bind(this);
    this.logoutClick = this.logoutClick.bind(this);
    this._storeDb = storedb();
  }

  componentDidMount() {
    this.getHeaderInfo()
    this.checkMustChangePwd()

    if (typeof this.props.header.storeIntervalIds === 'function') {
      this.props.header.storeIntervalIds(setInterval(() => {
        var alerts = this._storeDb.getAlerts();
        if (alerts.length > 0) {
          this.showAlert(alerts);
        }
      }, 1000));

      this.props.header.storeIntervalIds(setInterval(() => {
        this.getHeaderInfo()
      }, AppConfig.TIMEOUT_LOAD_HEADER_INFO))
    }
  }

  toggleFb = () => {
    try {
      if (!EnvConfig.IS_LOCAL) {
        this.setState({
          showFbMsg: !this.state.showFbMsg,
          flagFbMsg: false
        }, () => {
          if (!this.state.showFbMsg) {
            FB.CustomerChat.hide();
          } else {
            FB.CustomerChat.show();
          }
        });

        setTimeout(() => this.setState({ flagFbMsg: true }), 1000);
      }
    } catch (error) {
      console.log(error);
    }
  }

  showAlert = (alerts) => {
    for (var i = 0; i < alerts.length; i++) {
      if (toast.isActive(alerts[i].key)) {
        return;
      }

      toast(<ToastElement alert={alerts[i]} />, {
        toastId: alerts[i].key,
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
        onClose: ({ alert }) => {
          this._storeDb.removeAlert(alert);
        }
      });
    }
  }
  checkMustChangePwd = () => {
    const info = parserToken(localStorage.getItem('token'));
    if (info.RequireChangePwd) {
      this.setState({modalChangePasswordFlag: true})
    }
  }
  getHeaderInfo = () => {
    const { headerRequest } = this.props
    return headerRequest({ history: this.props.history })
  }
  toggle(i) {
    const newArray = this.state.dropdownOpen.map((element, index) => {
      return (index === i ? !element : false);
    });
    this.setState({
      dropdownOpen: newArray
    });
  }
  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  logoutClick = (e) => {
    this.props.logout();
    this.props.history.push('/login');
  }
  changePassword = () => {
    this.setState({modalChangePasswordFlag: false})
    this.props.history.push('/changePassword')
  }
  getVal = (obj) => {
    if (!obj) {
      return 0;
    }
    if (!obj.value) {
      return 0;
    }
    return parseInt(obj.value);
  }
  persDeniedDlgClose = () => {
    this.setState({
      modalAceessDenedFlag: !this.state.modalAceessDenedFlag,
    });
  }
  onNotificationClick = (item) => {
    if(item.url && item.url != ''){
      this.props.history.push(item.url);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.header.type == ACCESS_DENIED_ACTION) {
      if (!this.state.modalAceessDenedFlag) {
        this.setState({
          modalAceessDenedFlag: !this.state.modalAceessDenedFlag,
        });
      }
    }
    if (nextProps.header.type == HEADER_REQUEST_SUCCESS) {
      this.setState({
        data: nextProps.header.data
      })
    }
  }

  render() {
    const {
      data: {
        user,
        notifications,
      },
    } = this.state;

    const countNotify = notifications ? notifications.reduce((totalValue, noti) => totalValue + noti.value, 0) : 0;

    const isMobile = isMobileAndTablet();

    return (
      <header className="app-header navbar">
        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>&#9776;</NavbarToggler>
        <NavbarBrand href="#">
          <img className="img-logo-brand" src={this._storeDb.getLogoOfStore()} />
        </NavbarBrand>
        <NavbarToggler className="d-md-down-none" onClick={this.sidebarToggle}>&#9776;</NavbarToggler>
        <Nav className="d-md-down-none" navbar>
          <NavItem className="px-3">
            <i className="fa fa-clock-o"></i>&nbsp;<Clock />
          </NavItem>
        </Nav>
        {/* User login info */}
        <Nav className="ml-auto" navbar>
          <NavItem>
            <Online {...this.props}></Online>
          </NavItem>
          <NavItem className="dropdown small-nav-item" >
            <Dropdown 
              onMouseEnter = {() => this.toggle(0) }
              onMouseLeave = {() => this.toggle(0) }
              isOpen={this.state.dropdownOpen[0]} 
              toggle={() => this.toggle(0) }
              >
              <DropdownToggle className="nav-link dropdown-toggle">
                <i className="icon-bell"></i><Badge pill color="success">{countNotify}</Badge>
              </DropdownToggle>
              <DropdownMenu right className={this.state.dropdownOpen[0] ? 'show' : ''}>
                <DropdownItem header tag="div" className="text-center"><strong>Thông báo</strong></DropdownItem>
                {notifications && !!notifications.length && (
                  notifications.map((item, idx) => (
                    <DropdownItem onClick={() => this.onNotificationClick(item)} key={idx + 1}><i className={item.icon + " fa fa-lg"}></i>
                      <Badge pill color="success" className={"badge_custom"}>{item.value}</Badge>{item.text}
                    </DropdownItem>
                  ))
                )}
              </DropdownMenu>
            </Dropdown>
          </NavItem>
          {/* User context menu*/}
          <NavItem>
            <Dropdown 
              onMouseEnter = {() => this.toggle(1) }
              onMouseLeave = {() => this.toggle(1) }
              isOpen={this.state.dropdownOpen[1]} 
              toggle={() => this.toggle(1)}
              >
              <DropdownToggle className="nav-link dropdown-toggle">
                {user && (
                  <span>
                    <img src={"img/avatars/9.png"} className="img-avatar" alt={user.email} />
                    <span className="d-md-down-none">{user.TenDayDu}</span>
                  </span>
                )}
              </DropdownToggle>
              <DropdownMenu right className={this.state.dropdownOpen[1] ? 'show' : ''}>
                <DropdownItem header tag="div" className="text-center"><strong>{user.TenDayDu}</strong></DropdownItem>
                {/* <DropdownItem><i className="fa fa-user"></i> <Link to="/myaccount">Thông tin cá nhân</Link></DropdownItem> */}
                <DropdownItem><i className="fa fa-key"></i><Link to="/changepassword">Đổi mật khẩu</Link> </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={this.logoutClick}>
                  <i className="fa fa-lock"></i>Đăng xuất
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </NavItem>
        </Nav>
        <ToastContainer autoClose={30000} />
        <AccessDenied
          {...this.props}
          logoutClick={this.logoutClick}
          onClose={this.persDeniedDlgClose.bind(this)}
          isOpen={this.state.modalAceessDenedFlag}
        />
        <CheckChangePassword
          changePassword={(e) => this.changePassword(e)}
          isOpen={this.state.modalChangePasswordFlag}
        />
        {!!isMobile && (
          <Offline polling={{ interval: 30000 }}>
            <div className="offline_alert">
              <div>
                <label><b>Mất kết nối mạng...</b></label>
              </div>
            </div>
          </Offline>
        )}
      </header>
    )
  }
}

const mapStateToProps = state => ({
  header: state.header,
})

const connected = connect(mapStateToProps, {
  headerRequest,
  logout,
  headerSetActiveBranchRequest,
})(Header)

const formed = reduxForm({
  form: 'header',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js